window.addEventListener('load', () => {
    const parallax = document.querySelector("[data-prlx]");
    if (!parallax)
        return;
    const module = import('./parallax');
    module.then((mod) => mod.default());
});
